import Section from 'umg-ember-backend/components/record-explorer/for/section';

<template><Section @records={{@model}} @recordType='section' /></template>
